import { Component, OnInit, Input } from '@angular/core';
import { SummaryRating } from 'app/shared/models/summaryRating.model';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {
    @Input() ratings: string;
    @Input() completed: SummaryRating[];
    @Input() auditsPerMonth: SummaryRating[];
    summaryRatingList: SummaryRating[];

    positiveRating: number;
    completedAudits: number;
    completedAuditJSON: string;
    auditsPerMonthJSON: string;
    auditsPerMonthAv: number;

    //view: any[] = [600, 400];
    view: any;

    // options for the chart
    showXAxis = true;
    showYAxis = true;
    gradient = false;
    showLegend = true;
    showXAxisLabel = true;
    xAxisLabel = 'Country';
    showYAxisLabel = true;
    yAxisLabel = 'Sales';
    timeline = true;

    colorScheme = {
        domain: ['#9370DB', '#87CEFA', '#FA8072', '#FF7F50', '#90EE90', '#9370DB']
    };

    whitePalette = {
        domain: ['#FFFFFF']
    }
    bluePalette = {
        domain: ['#27aae1']
    }
    trafficLightPalette = {
        domain: ['#28a745', '#ffc107','#dc3545']
    }
    greenRedPalette = {
        domain: ['#28a745', '#dc3545']
    }

    //pie
    showLabels = true;

 

    constructor() { }

    ngOnInit() {
        this.summaryRatingList = JSON.parse(JSON.stringify(this.ratings));
        this.positiveRating = this.summaryRatingList.find(x => x.name === 'Positive').value;

        this.completedAuditJSON = JSON.stringify(this.completed);
        this.completedAudits = this.completed.find(x => x.name === 'Completed').value;

        this.auditsPerMonthJSON = JSON.stringify(this.auditsPerMonth);
        this.auditsPerMonthAv = this.auditsPerMonth.reduce((a, b) => a + b.value, 0) / this.auditsPerMonth.length;
    }

}
